export default __webpack_public_path__ + "static/media/ofc.0985fa4d.png";